module.exports = __webpack_public_path__ + "static/img/logo.ab00c761.svg";